"use client";

import clsx from "clsx";
import type { ComponentProps, ReactNode } from "react";

import { Body } from "@shared/ui/typography";

import s from "./detail-info-list-item.module.scss";

export type DetailInfoListItemProps = ComponentProps<"div"> & {
  className?: string;
  title: ReactNode;
  children: ReactNode;
  titleSize?: "uppercase" | "uppercase-small" | "caption" | "special";
  isHtml?: boolean;
};

export const DetailInfoListItem = (props: DetailInfoListItemProps) => {
  const {
    className,
    title,
    children,
    titleSize = "uppercase",
    isHtml = false,
  } = props;

  return (
    <div className={clsx(s.root, className)}>
      <Body className={s.title} weight="semiBold" size={titleSize}>
        {title}
      </Body>
      {isHtml && typeof children === "string" ? (
        <div
          dangerouslySetInnerHTML={{ __html: children }}
          className={s.value}
        />
      ) : (
        <div className={s.value}>{children}</div>
      )}
    </div>
  );
};

DetailInfoListItem.displayName = "DetailInfoListItem";
